import { useFormikContext } from "formik"
import React from "react"
import { useRouteLoaderData } from "react-router-dom"
import { findField } from "@app/utils/form"

export const useQualificationObserver = (currentFieldsets) => {
	const { values } = useFormikContext()

	const { office } = useRouteLoaderData("root")
	const jobLocationID = values.kundenundeinsatzort_einsatzort_adressetyp
	const customerId = values.kundenundeinsatzort_kunde_kunde__ID
	const customer = office?.kundenliste.find(({ KUNDENNR }) => {
		return KUNDENNR.toString() === customerId?.toString()
	},)
	let jobLocation = customer?.EinsatzAdressen?.find(({ Adresse }) => Adresse === jobLocationID)
	if (!jobLocation) {
		jobLocation = customer?.EinsatzAdressen?.find(({ ist_Kundenadresse }) => ist_Kundenadresse === true)
	}
	const value_ueberlassungalsId = values["taetigkeit_beschreibung_ueberlassungals__ID"]

	let res = React.useMemo(() => {
		if (customerId) {
			const jobObj = jobLocation?.Berufe?.find(({ Berufschluessel }) => Berufschluessel === value_ueberlassungalsId)
			const qualifications = jobObj?.Qualifikation?.split?.(";")
				?.map(entry => entry.trim())
				?.map(quali => ({
					id: quali,
					label: quali,
					value: quali,
				}))

			const qualiForm = findField(currentFieldsets, "taetigkeit_erforderlichequalifikationen_form")
			const qualiField = qualiForm?.formGroup?.elements.find(({ name }) => name === "taetigkeit_erforderlichequalifikationen_form_qualifikationen")

			if (qualiField) {
				qualiField.options = qualifications
				qualiField.showAsHeader = true
			}
			return {
				fieldsets: currentFieldsets
			}
		}

		return {
			fieldsets: currentFieldsets
		}
	}, [jobLocation, customerId, value_ueberlassungalsId, currentFieldsets])
	return res
}

const QualificationObserver = ({ currentFieldsets, setCurrentFieldsets }) => {
	const { fieldsets } = useQualificationObserver(currentFieldsets)
	setCurrentFieldsets(fieldsets)
	return null
}

export default QualificationObserver
